import React from 'react';
import { ReactComponent as Check } from '../../assets/images/icons/check.svg';

export default function CheckIcon(props) {
  return (
    <Check className={`icon ${props.className}`} />
  );
}
